import axios, { AxiosInstance } from 'axios'
import { BaseUrls } from './base-urls'

let ClientsAxios: any = {}
Object.keys(BaseUrls).forEach((base: any) => {
    ClientsAxios[base] = axios.create({ baseURL: BaseUrls[base].url })
    addInterceptor(ClientsAxios[base], BaseUrls[base].config)
})

function addInterceptor(instance: AxiosInstance, requestExtension: any): AxiosInstance {
    instance.interceptors.request.use((request) => {
        // Set the Accept header for all requests
        request.headers['Accept'] = 'Application/json';

        // Retrieve the access token from localStorage
        const token = localStorage.getItem('access_token');
        
        // If the token exists, add it to the Authorization header
        if (token) {
            request.headers['Authorization'] = `Bearer ${token}`; // Add the Bearer token
        }

        // Set Content-Type to application/json if not set already
        if (!request.headers['Content-Type']) {
            request.headers['Content-Type'] = 'application/json';
        }

        return request
    }, (error) => {
        return Promise.reject(error)
    })

    instance.interceptors.response.use((response) => {
        return response
    }, (error) => {
        console.log(error);
        if (error && error.response) {
            // Handle other response errors as needed
            // Optionally, you can uncomment this line if you want to show a snackbar for error messages
            // store.dispatch(showSnackbar({ open: true, type: 'error', message: error.response.data.message ? error.response.data.message : 'Something went wrong' }))
        }
        return Promise.reject(error);
    })
    return instance
}

export default ClientsAxios
